import i18n from "../../locales/i18n";
export default {
  ConvertToAssetList(_assetList) {
    let assetList = [];
    _assetList.forEach((_asset) => {
      let asset = {
        id: _asset.id,
        code: _asset.code,
        stopAssetDepreciationDate: _asset.stopAssetDepreciationDate,
        isStopAssetDepreciation: _asset.isStopAssetDepreciation,
        saleAssetTransactionId: _asset.saleAssetTransactionId,
        saleAssetTransactionType: _asset.saleAssetTransactionType,
      };
      assetList.push(asset);
    });

    return assetList;
  },
  ConvertToAssetTemplateCodeList(assetTemplateCodeListRaw) {
    const assetTemplateCodeList = [];

    if (assetTemplateCodeListRaw && assetTemplateCodeListRaw.length > 0) {
      for (const assetTemplateCodeRaw of assetTemplateCodeListRaw) {
        assetTemplateCodeList.push({
          id: assetTemplateCodeRaw.id,
          assetTemplateCode: assetTemplateCodeRaw.assetTemplateCode,
        });
      }
    }
    return assetTemplateCodeList;
  },
  ToAssetTemplateList(assetTemplateListRaw) {
    const assetTemplateList = [];
    if (assetTemplateListRaw && assetTemplateListRaw.length > 0) {
      for (const _assetTemplate of assetTemplateListRaw) {
        assetTemplateList.push({
          id: _assetTemplate.id,
          code: _assetTemplate.assetTemplateCode,
          nameTh: _assetTemplate.nameTh,
          nameEn: _assetTemplate.nameEn,
          name: i18n.locale == "th" ? _assetTemplate.nameTh : _assetTemplate.nameEn,
          assetCategoryId: _assetTemplate.assetCategoryId,
          assetSubcategoryId: _assetTemplate.assetSubcategoryId,
          accountDepreciationMethodId: _assetTemplate.accountDepreciationMethodId,
          assetAccountId: _assetTemplate.assetAccountId,
          depreciationAccountId: _assetTemplate.accountDepreciationMethodId,
          accumulatedDepreciationAccountId: _assetTemplate.accumulatedDepreciationAccountId,
          accountUsefullYear: _assetTemplate.accountUsefullYear,
          accountScrapAmount: _assetTemplate.accountScrapAmount,
          accountScrapTypeId: _assetTemplate.accountScrapTypeId,
          accountScrapVal: _assetTemplate.accountScrapVal,
          accountValPurchaseAmount: _assetTemplate.accountValPurchaseAmount,
          accountValPurchaseTypeId: _assetTemplate.accountValPurchaseTypeId,
          accountValPurchase: _assetTemplate.accountValPurchase,
          isDeleted: _assetTemplate.isDeleted,
          description: _assetTemplate.description,
          remark: _assetTemplate.remark,
          unitId: _assetTemplate.assetUnitId,
          unitNameEn: "",
          unitNameTh: "",
        });
      }
    }
    return assetTemplateList;
  },
  ToAutoCompleteAssetTemplateList(autoCompleteAssetTemplateListRaw) {
    const autoCompleteAssetTemplateList = [];
    if (autoCompleteAssetTemplateListRaw && autoCompleteAssetTemplateListRaw.length > 0) {
      for (const autoCompleteAssetTemplate of autoCompleteAssetTemplateListRaw) {
        autoCompleteAssetTemplateList.push({
          id: autoCompleteAssetTemplate.id,
          code: autoCompleteAssetTemplate.code,
          nameTh: autoCompleteAssetTemplate.nameTh,
          nameEn: autoCompleteAssetTemplate.nameEn,
          name: i18n.locale == "th" ? autoCompleteAssetTemplate.nameTh : autoCompleteAssetTemplate.nameEn,
          assetCategoryId: 0,
          assetSubcategoryId: 0,
          accountDepreciationMethodId: 0,
          assetAccountId: autoCompleteAssetTemplate.assetAccountId,
          depreciationAccountId: 0,
          accumulatedDepreciationAccountId: 0,
          accountUsefullYear: 0,
          accountScrapAmount: autoCompleteAssetTemplate.scarpAmount,
          accountScrapTypeId: autoCompleteAssetTemplate.scrapType,
          accountScrapVal: autoCompleteAssetTemplate.scrapVal,
          accountValPurchaseAmount: 0,
          accountValPurchaseTypeId: 0,
          accountValPurchase: 0,
          isDeleted: false,
          description: "",
          remark: "",
          unitId: 0,
          unitNameEn: "",
          unitNameTh: "",
        });
      }
    }
    return autoCompleteAssetTemplateList;
  },
  ToAssetTemplateCacheList(assetTemplateCacheListRaw) {
    const assetTemplateList = [];
    if (assetTemplateCacheListRaw && assetTemplateCacheListRaw.length > 0) {
      for (const assetTemplateCache of assetTemplateCacheListRaw) {
        assetTemplateList.push({
          id: assetTemplateCache.id,
          code: assetTemplateCache.code,
          nameTh: assetTemplateCache.nameTh,
          nameEn: assetTemplateCache.nameEn,
          name: i18n.locale == "th" ? assetTemplateCache.nameTh : assetTemplateCache.nameEn,
          assetCategoryId: assetTemplateCache.assetCategoryId,
          assetSubcategoryId: assetTemplateCache.assetSubcategoryId,
          accountDepreciationMethodId: assetTemplateCache.accountDepreciationMethodId,
          assetAccountId: assetTemplateCache.assetAccountId,
          depreciationAccountId: assetTemplateCache.depreciationAccountId,
          accumulatedDepreciationAccountId: assetTemplateCache.accumulatedDepreciationAccountId,
          accountUsefullYear: assetTemplateCache.accountUsefullYear,
          accountScrapAmount: assetTemplateCache.accountScrapAmount,
          accountScrapTypeId: assetTemplateCache.accountScrapTypeId,
          accountScrapVal: assetTemplateCache.accountScrapVal,
          accountValPurchaseAmount: assetTemplateCache.accountValPurchaseAmount,
          accountValPurchaseTypeId: assetTemplateCache.accountValPurchaseTypeId,
          accountValPurchase: assetTemplateCache.accountValPurchase,
          isDeleted: assetTemplateCache.isDeleted,
          description: assetTemplateCache.description,
          remark: assetTemplateCache.remark,
          unitId: assetTemplateCache.unitId,
          unitNameEn: assetTemplateCache.unitNameEn,
          unitNameTh: assetTemplateCache.unitNameTh,
        });
      }
    }
    return assetTemplateList;
  },
};
